import { useQuery } from '@tanstack/react-query';
import { getIssueReportOffer } from '@/api/issue-report-offer.api';
import { issueReportOfferKeys } from './issue-report-offer.queries';

interface UseIssueReportOfferOptions {
  /** False for a caller that has no use for the offer (e.g. a CMS band with no tokens), so no request fires. */
  enabled?: boolean;
}

/**
 * The current Issue Report offer (FR-201): price, access length and the one
 * plan the purchase journey may check out, or `coming_soon`. `staleTime`
 * matches the endpoint's own `Cache-Control: max-age=60`, so an admin's plan
 * change shows within a minute with no deploy (FR-203). No retry on a failure:
 * every reader renders a neutral state and the journey page offers its own
 * retry, so a slow retry loop would only hold the neutral state longer.
 */
export function useIssueReportOffer({ enabled = true }: UseIssueReportOfferOptions = {}) {
  return useQuery({
    queryKey: issueReportOfferKeys.all,
    queryFn: getIssueReportOffer,
    staleTime: 60_000,
    retry: false,
    enabled,
  });
}
